import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { Instance } from '@popperjs/core';
import { colors } from 'crono-fe-common/theme';
import React from 'react';

export const CustomOptionsTooltip = styled(
  ({
    className,
    popperRef,
    ...props
  }: TooltipProps & {
    left?: number;
    top?: number;
    minWidth?: number | string;
    width?: number | string;
    height?: number | string;
    maxHeight?: number | string;
    overflow?: string;
    padding?: number | string;
    borderRadius?: number | string;
    zIndex?: number | string;
    popperRef?: React.MutableRefObject<Instance | null>;
  }) => (
    <Tooltip
      arrow={props.arrow ? props.arrow : false}
      {...props}
      PopperProps={{
        popperRef,
      }}
      classes={{ popper: className }}
    />
  ),
)(
  ({
    left,
    top,
    width,
    minWidth,
    height,
    maxHeight,
    overflow,
    padding,
    borderRadius,
    zIndex,
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      position: 'relative',
      top: top !== undefined ? top : -8,
      left: left !== undefined ? left : -8,
      backgroundColor: 'white',
      color: 'rgba(0, 0, 0, 0.87)',
      height: height ? height : undefined,
      maxHeight: maxHeight ? maxHeight : 100,
      width: width ? width : 500,
      minWidth: minWidth ? minWidth : undefined,
      border: `1px solid ${colors.grey4}`,
      borderRadius: borderRadius ? borderRadius : 8,
      padding: padding ? padding : 0,
      WebkitBoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
      MozBoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
      OBoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
      BoxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
      display: 'flex',
      overflow: overflow ? overflow : 'auto',
      zIndex: zIndex ? zIndex : 1600,
    },
  }),
);
